export function getDepartmentError(error: any): string {
  const raw = error?.message;
  const message = Array.isArray(raw) ? raw.join(', ') : raw;

  if (message === 'DEPARTMENT_CODE_ALREADY_EXISTS') return 'Mã bộ phận đã tồn tại.';
  if (message === 'DEPARTMENT_NOT_FOUND') return 'Không tìm thấy bộ phận này. Hãy tải lại danh sách.';

  const inUse = typeof message === 'string' && message.match(/^DEPARTMENT_IN_USE_BY_(\d+)_USERS$/);
  if (inUse) return `Không thể xoá: còn ${inUse[1]} user thuộc bộ phận này.`;

  if (typeof message === 'string' && message && !message.startsWith('DEPARTMENT_')) {
    return message;
  }
  return 'Thao tác thất bại. Vui lòng thử lại.';
}
